function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".legal-cls-1{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.legal-cls-1,.legal-cls-2{stroke:#2e4150;}.legal-cls-2{fill:#2e4150;stroke-miterlimit:10;stroke-width:0.75px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Calque_2",
  "data-name": "Calque 2"
}, React.createElement("g", {
  id: "Contenu"
}, React.createElement("polygon", {
  className: "legal-cls-1",
  points: "25 9.44 25 1 16.56 1 9.44 1 1 1 1 9.44 1 16.56 1 25 9.44 25 16.56 25 25 25 25 16.56 25 9.44"
}), React.createElement("path", {
  className: "legal-cls-2",
  d: "M9.8,12a.37.37,0,0,1-.31-.17.37.37,0,0,1,.12-.51l4.85-3a.37.37,0,0,1,.51.11.38.38,0,0,1-.12.51L10,12A.46.46,0,0,1,9.8,12Z"
}), React.createElement("path", {
  className: "legal-cls-2",
  d: "M11.35,14.54a.37.37,0,0,1-.2-.68l4.85-3a.36.36,0,0,1,.51.12.36.36,0,0,1-.12.5l-4.85,3A.35.35,0,0,1,11.35,14.54Z"
}), React.createElement("path", {
  className: "legal-cls-2",
  d: "M16.87,11.93a1,1,0,0,1-.25,0,1.09,1.09,0,0,1-.69-.5L14.29,8.76a1.1,1.1,0,0,1,.36-1.52l.53-.34A1.15,1.15,0,0,1,16,6.76a1.13,1.13,0,0,1,.69.5L18.33,9.9A1.1,1.1,0,0,1,18,11.42l-.53.34A1.12,1.12,0,0,1,16.87,11.93ZM15.76,7.47a.35.35,0,0,0-.19.06h0L15,7.86a.37.37,0,0,0-.12.51L16.56,11a.36.36,0,0,0,.22.16.36.36,0,0,0,.27,0l.54-.33a.38.38,0,0,0,.12-.51L16.07,7.64a.35.35,0,0,0-.23-.16Z"
}), React.createElement("path", {
  className: "legal-cls-2",
  d: "M10.24,16.07A1,1,0,0,1,10,16a1.08,1.08,0,0,1-.69-.49L7.67,12.9A1.09,1.09,0,0,1,8,11.39l.53-.34a1.06,1.06,0,0,1,.83-.14,1.12,1.12,0,0,1,.69.49l1.64,2.65a1.11,1.11,0,0,1-.36,1.52l-.53.34A1.1,1.1,0,0,1,10.24,16.07Zm-1.1-4.45a.38.38,0,0,0-.19.05H9L8.41,12a.37.37,0,0,0-.12.5l1.64,2.65a.37.37,0,0,0,.22.17.39.39,0,0,0,.28-.05L11,15a.37.37,0,0,0,.12-.51L9.44,11.79a.36.36,0,0,0-.22-.16Z"
}), React.createElement("path", {
  className: "legal-cls-2",
  d: "M16.94,19.27a1,1,0,0,1-.25,0,1.13,1.13,0,0,1-.69-.5l-3.34-5.4a.37.37,0,0,1,.63-.39l3.34,5.41a.36.36,0,0,0,.22.16.35.35,0,0,0,.28-.05l.34-.21a.36.36,0,0,0,.12-.51l-3.34-5.4a.37.37,0,0,1,.63-.39l3.34,5.4a1.11,1.11,0,0,1-.35,1.52l-.35.22A1.12,1.12,0,0,1,16.94,19.27Z"
})));

var SvgLegal = function SvgLegal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLegal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/legal.c017ea9a.svg";
export { ForwardRef as ReactComponent };